var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ThumbBase',{staticClass:"IndependentCourseThumb",attrs:{"image":_vm.image,"title":_vm.title,"icon":_vm.icon},on:{"click":function($event){return _vm.gotoCourse()}}})}
var staticRenderFns = []

export { render, staticRenderFns }